let $featuredCategoryScroll;
let featuredCategorySections;

function initMobileCarousel() {
    if($featuredCategoryScroll.length < 1) return;

    $featuredCategoryScroll.slick({
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 481,
                settings: 'unslick'
            }
        ]
    });
}

function equalizeCardHeight() {
    const $parent = $('.featured-category__story-telling-selling');
    if($($parent).length) {
        $($parent).each(function () {
            let cards = $(this).find('.featured-category-tiles-section .featured-category__product-tile .featured-category__product-content');
            let maxHeight = 0;

            $(cards).each(function () {
                let thisHeight = $(this).outerHeight();
                if(thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $(cards).each(function () {
                $(this).css('height', maxHeight + 'px');
            });
        });
    }
}

$(function () {
    $featuredCategoryScroll = $('.featured-category__product-tiles-container');
    featuredCategorySections = $('.featured-category__section');
    initMobileCarousel();
    $(window).resize(function () {
        slickUnslickCarousel();
        equalizeCardHeight();
        featuresCategorySectionsEqualize();
    });

    equalizeCardHeight();
    featuresCategorySectionsEqualize();
});

function featuresCategorySectionsEqualize() {
    if(featuredCategorySections.length) {
        $(featuredCategorySections).each(function () {
            let cards = $(this).find('.featured-category__column.featured-category__product-tiles-container .featured-category__product-content .featured-category__product-description');
            let maxHeight = 0;

            $(cards).each(function () {
                let thisHeight = $(this).outerHeight();
                if(thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $(cards).each(function () {
                $(this).css('height', maxHeight + 'px');
            });
        });
    }
}

function slickUnslickCarousel() {
    // reslick on resizing window from medium to small screens
    if($(window).width() <= 480) {
        $($featuredCategoryScroll).slick('unslick');
        initMobileCarousel();
    } else {
        if($($featuredCategoryScroll).hasClass('slick-initialized')) {
            $($featuredCategoryScroll).slick('unslick');
        }
    }
}

$(window).on('load', function() {
    slickUnslickCarousel();
});
